var createReactClass = require('create-react-class');
import React from 'react';
import { MultiSelect } from "react-multi-select-component";

const PeerReviewPanel = createReactClass({
  getInitialState: function() {
    return {
      reviewer_pool: 1,
      specialty_id: this.props.userProfile.specialty_id,
      category_ids: this.props.userProfile.category_ids
    }
  },

  handleSpecialtyChange: function(selectedOptions) {
    this.setState({ specialty_id: selectedOptions || [] })
  },

  handleCategoryChange: function(selectedOptions) {
    if (selectedOptions.length <= 5) {
      this.setState({ category_ids: selectedOptions || [] })
    } else {
      alert("You can select up to 5 categories");
    }
  },

  renderSpecialtyOptions: function() {
    const filteredSpecialties = this.props.specialties;

    return (
      <div>
        <MultiSelect
          options={filteredSpecialties || []}
          value={this.state.specialty_id || []}
          onChange={this.handleSpecialtyChange}
          labelledBy={"Select Specialty"}
          disabled={true}
        />
      </div>
    );
  },

  renderCategoryOptions: function() {
    const specialties = this.props.specialties.map(option => option.value);
    const filteredCategories = this.props.categories.filter(spec => specialties.includes(spec.specialty_id));

    return (
      <div>
        <MultiSelect
          options={filteredCategories || []}
          value={this.state.category_ids || []}
          onChange={this.handleCategoryChange}
          labelledBy={"Select Category"}
          hasSelectAll={false}
        />
      </div>
    );
  },

  renderButton: function(payload, route, callback) {
    const disabled = this.isPhD() ?  "" : " disabled"
    return <a onClick={() => this.props.handleSubmit(payload, route, callback)} className={"button special" + disabled}>Save</a>
  },

  isPhD: function() {
    return this.props.userProfile.qualification == 'Ph.D.'
  },

  renderPhdHelp: function() {
    return (
      <div style={{color: 'indianred'}}>
        *Only authors with <strong>Ph.D.</strong> qualification can join Peer Review Panel.
      </div>
    )
  },

  render: function(){
    return (
      <div className="reveal-modal medium" data-reveal data-options={this.props.setUncloseable()}>
      <div className="modal-body">
        {this.props.renderFlash()}
        {this.props.renderModalCloseX()}

        <div className="modal-content">
          <h4>Apply to Join Our Peer Review Panel</h4>
          <p>We invite you to lend a hand to your fellow Cureus Journals authors and volunteers by joining our peer review panel. Fill in your details below. We'll review your qualifications (minimum requirement - Ph.D. completed in relevant subject area) and experience and contact you with any questions or concerns. Reviewing with Cureus Journals is easy and hassle-free!</p>
          <div className="row">
              <div className="large-6 medium-6 columns">
                <label><strong>Specialties -</strong></label>
                {this.renderSpecialtyOptions()}
              </div>
          </div>
          <br></br>
          <div className="row">
              <div className="large-6 medium-6 columns">
                <label><strong>Select Categories - </strong></label>
                {this.renderCategoryOptions()}
              </div>
          </div>
          <br></br>
        </div>
        {this.props.renderErrors()}
        <div className='modal-footer'>
          <div className="" style={{ textAlign: 'left' }}>
            {!this.isPhD() && this.renderPhdHelp()}
          </div>
          <div>
            {this.renderButton({user: this.state, section: 'PeerReviewPanelForm'}, this.props.updateProfilePath, () => this.props.forceUpdate())}
          </div>
        </div>
      </div>
    </div>
    )
  }
})

export default PeerReviewPanel;